import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconChevronLargeDown"><Path d="M21.5 9.5L12 14.5L2.5 9.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconChevronLargeDown;
